<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('order.order_suggested-receiving-location') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
          :master-data="suggestedReceivingLocation"
        >
          <template #postalCode="{ item }">
            <!-- 郵便番号 -->
            <PostalCodeArea
              v-model="item.postalCode"
              :height="inputFormStyle.inputItemHeight"
              :countryId="item.country.value"
              @click="getAddressFromPostalCode"
            />
          </template>
        </InputFormNew>
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, PostalCodeArea, NormalButton } from '@/components/items'
import { countryCallingCodeUtil, countryUtil } from '@/util'
export default {
  components: {
    DialogBase,
    InputFormNew,
    PostalCodeArea,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    buttonName: { default: 'common.input_save' },
    suggestedReceivingLocationData: {
      type: Object,
      require: false,
      default: () => ({})
    },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9,
      inputItemHeight: '32px'
    },
    inputData: {},
    suggestedReceivingLocation: [],
    items: [
      {
        name: 'location',
        text: 'order.order_suggested-receiving-location',
        required: true
      },
      {
        name: 'phone',
        text: 'common.input_phone-number',
        required: true,
        component: 'PhoneNumberInput'
      },
      {
        name: 'country',
        text: 'common.input_country',
        cols: Math.ceil(5),
        required: true,
        component: 'SelectCountry'
      },
      {
        name: 'postalCode',
        text: 'common.input_postal-code',
        cols: Math.ceil(5)
      },
      {
        name: 'region',
        text: 'common.input_region',
        cols: Math.ceil(5),
        required: true,
        component: 'SelectRegion'
      },
      {
        name: 'address1',
        text: 'common.input_address_1',
        required: true,
        placeholder: 'common.input_municipality'
      },
      {
        name: 'address2',
        text: 'common.input_address_2',
        placeholder: 'common.input_after-house-number'
      },
      {
        name: 'sortNumber',
        text: 'common.input_sort-number',
        required: true,
        placeholder: '',
        cols: Math.ceil(5),
        component: 'SelectSortNumber'
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('Supplier', [
      'registerSuggestedReceivingLocation',
      'editSuggestedReceivingLocation'
    ]),
    ...mapGetters('Supplier', [
      'getSuggestedReceivingLocationMaxSortNumber',
      'getSuggestedReceivingLocationListFromState'
    ]),
    ...mapGetters('Common', [
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState'
    ]),
    ...mapActions('Common', ['getCountryListFromApi']),

    getAddressFromPostalCode(...args) {
      const [address] = args

      this.inputData.region = countryUtil.getRegionInfoByName(
        this.inputData.country.value,
        address.region
      )
      this.inputData.address1 = address.locality
      this.inputData.address2 = address.street
    },
    setCountryCallingCode(countryId) {
      return this.editMode
        ? countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
        : this.getCountryCallingCodeJpFromState()
    },
    setCountryId(countryId) {
      return this.editMode
        ? countryUtil.getCountryIdInfo(countryId)
        : this.getCountryJpFromState()
    },
    init() {
      const formatData = { ...this.suggestedReceivingLocationData }
      formatData.phone = {
        countryCode: this.setCountryCallingCode(
          this.suggestedReceivingLocationData.phoneNumberCountryId
        ),
        phoneNumber: this.suggestedReceivingLocationData.phoneNumber
      }
      formatData.country = this.setCountryId(
        this.suggestedReceivingLocationData.addressCountryId
      )
      formatData.region = countryUtil.getRegionInfo(
        this.suggestedReceivingLocationData.addressCountryId,
        this.suggestedReceivingLocationData.regionId
      )
      formatData.sortNumber = this.editMode
        ? this.suggestedReceivingLocationData.sortNumber
        : this.getSuggestedReceivingLocationMaxSortNumber() + 1

      this.inputData = formatData
      this.suggestedReceivingLocation =
        this.getSuggestedReceivingLocationListFromState()
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.suggestedReceivingLocationId
      }
      const success = this.editMode
        ? await this.editSuggestedReceivingLocation(this.inputData)
        : await this.registerSuggestedReceivingLocation(this.inputData)

      if (success) {
        // 都道府県がStringで追加された場合用に国マスタを再度取得
        this.getCountryListFromApi()
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
